import CancelBackButton from "Common/Components/Buttons/CancelBackButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import { STATUS_CONSTANT } from "Constants/StatusConstant";
import { showConfirm, showWarning } from "helpers/swalHelper";
import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Item } from "./CreateGRNTable";
import { MecordColors } from "Constants/Color";
import CancelButton from "Common/Components/Buttons/CancelButton";

interface QcRow {
  product_id: string;
  product_name: string;
  product_code: string;
  qc: (typeof STATUS_CONSTANT)[keyof typeof STATUS_CONSTANT];
  serial_no: string;
  warranty_date: string;
  remarks: string;
}

interface QcRowError {
  serial_no?: string;
  warranty_date?: string;
}

const ItemInwardAddStock: React.FC<{
  items: Item[];
  setItems: (items: any[]) => void;
  isAddStockOpen: boolean;
  setIsAddStockOpen: (val: boolean) => void;
  selectedItem: any;
  selectedItemIndex: number;
  rowData: any[];
  setRowData: (data: any[]) => void;
  formik?:any
}> = ({
  items,
  setItems,
  isAddStockOpen,
  setIsAddStockOpen,
  selectedItem,
  selectedItemIndex,
  rowData,
  setRowData,
  formik
}) => {
  const item = selectedItem;

  const [qcRows, setQcRows] = useState<QcRow[]>([]);
  const [qcErrors, setQcErrors] = useState<QcRowError[]>([]);

  useEffect(() => {
    if (!selectedItem || !isAddStockOpen) return;

    const currentReceivedQty = Number(selectedItem.received_quantity) || 0;
    const existingGrnProducts = Array.isArray(selectedItem.grn_products) 
      ? selectedItem.grn_products 
      : [];
    const existingGrnProductsLength = existingGrnProducts.length;

    // ✅ Case 1: Load already saved QC rows ONLY if received_quantity matches
    if (existingGrnProductsLength > 0 && existingGrnProductsLength === currentReceivedQty) {
      setQcRows(existingGrnProducts);
      setQcErrors(
        Array.from({ length: existingGrnProductsLength }, () => ({}))
      );
      return;
    }

    // ✅ Case 2: received_quantity changed or first-time Add Stock → recalculate
    const total = currentReceivedQty;
    const passCount = Number(selectedItem.quantity) || 0;

    // If we have existing grn_products and new quantity is higher, preserve existing data
    if (existingGrnProductsLength > 0 && total > existingGrnProductsLength) {
      // Preserve existing rows and add new ones
      const preservedRows: QcRow[] = existingGrnProducts.map((row: any) => ({
        product_id: selectedItem.product_id,
        product_name: selectedItem.product_name,
        product_code: selectedItem.product_code,
        qc: (row.qc || STATUS_CONSTANT.PASS) as (typeof STATUS_CONSTANT)[keyof typeof STATUS_CONSTANT],
        serial_no: row.serial_no || "",
        warranty_date: row.warranty_date || "",
        remarks: row.remarks || "",
      }));

      // Calculate how many new rows to add
      const newRowsCount = total - existingGrnProductsLength;
      const currentPassCount = preservedRows.filter(
        (row: QcRow) => row.qc === STATUS_CONSTANT.PASS
      ).length;
      const currentFailCount = preservedRows.filter(
        (row: QcRow) => row.qc === STATUS_CONSTANT.FAIL
      ).length;

      // Calculate how many new PASS and FAIL rows we need
      const neededPassCount = passCount - currentPassCount;
      const neededFailCount = (selectedItem.damaged_quantity || 0) - currentFailCount;

      const newRows: QcRow[] = [];
      let passAdded = 0;
      let failAdded = 0;

      for (let i = 0; i < newRowsCount; i++) {
        // Determine QC status for new rows
        let qcStatus: (typeof STATUS_CONSTANT)[keyof typeof STATUS_CONSTANT] = STATUS_CONSTANT.PASS;
        if (passAdded < neededPassCount) {
          qcStatus = STATUS_CONSTANT.PASS;
          passAdded++;
        } else if (failAdded < neededFailCount) {
          qcStatus = STATUS_CONSTANT.FAIL as (typeof STATUS_CONSTANT)[keyof typeof STATUS_CONSTANT];
          failAdded++;
        } else {
          // Default to FAIL if we've met all requirements
          qcStatus = STATUS_CONSTANT.FAIL as (typeof STATUS_CONSTANT)[keyof typeof STATUS_CONSTANT];
        }

        newRows.push({
          product_id: selectedItem.product_id,
          product_name: selectedItem.product_name,
          product_code: selectedItem.product_code,
          qc: qcStatus,
          serial_no: "",
          warranty_date: "",
          remarks: "",
        });
      }

      const allRows = [...preservedRows, ...newRows];
      setQcRows(allRows);
      setQcErrors(Array.from({ length: total }, () => ({})));
    } else {
      // Either first time or received_quantity decreased → regenerate all rows
      const rows: QcRow[] = Array.from({ length: total }, (_, i) => ({
        product_id: selectedItem.product_id,
        product_name: selectedItem.product_name,
        product_code: selectedItem.product_code,
        qc: i < passCount ? STATUS_CONSTANT.PASS : STATUS_CONSTANT.FAIL,
        serial_no: "",
        warranty_date: "",
        remarks: "",
      }));

      setQcRows(rows);
      setQcErrors(Array.from({ length: total }, () => ({})));
    }
  }, [selectedItem, isAddStockOpen]);

  const handleQcChange = (index: number, field: keyof QcRow, value: string) => {
  //   const receivedDate = formik.values.received_date;

  // // 🚨 Received date not selected
  // if (!receivedDate) {
  //   showWarning({
  //     title: "Missing Received Date",
  //     text: "Please select Received Date first",
  //   });
  //   return;
  // }
    // Validate serial number: only allow alphanumeric and spaces
    // if (field === "serial_no") {
    //   // Regex: allows alphanumeric and spaces only (no hyphens, underscores, or special symbols)
    //   const allowedPattern = /^[a-zA-Z0-9\s]*$/;
      
    //   // Filter out invalid characters but allow user to see what they're typing
    //   const filteredValue = value.split('').filter(char => /[a-zA-Z0-9\s]/.test(char)).join('');
      
    //   // Set error if original value contains special symbols
    //   const updatedErrors = [...qcErrors];
    //   if (!updatedErrors[index]) {
    //     updatedErrors[index] = {};
    //   }
      
    //   if (value && value !== filteredValue) {
    //     // User tried to enter special symbols - show error
    //     updatedErrors[index].serial_no = "Special symbols are not allowed. Only letters, numbers, and spaces are permitted.";
    //   } else if (updatedErrors[index]?.serial_no && filteredValue && allowedPattern.test(filteredValue)) {
    //     // Clear error if value is now valid
    //     updatedErrors[index].serial_no = undefined;
    //   }
      
    //   // Use filtered value (without special symbols)
    //   const updatedRows = [...qcRows];
    //   updatedRows[index] = {
    //     ...updatedRows[index],
    //     [field]: filteredValue,
    //   };
      
    //   setQcRows(updatedRows);
    //   setQcErrors(updatedErrors);
    //   return;
    // }

    // For other fields, update normally
    const updatedRows = [...qcRows];
    updatedRows[index] = {
      ...updatedRows[index],
      [field]: value,
    };

    const updatedErrors = [...qcErrors];
    if (updatedErrors[index]) {
      updatedErrors[index][field as keyof QcRowError] = undefined;
    }

    setQcRows(updatedRows);
    setQcErrors(updatedErrors);
  };

  const validateQcRows = (): boolean => {
    let isValid = true;
    const errors: QcRowError[] = [];

    const serialSet = new Set<string>();
    // Regex: allows alphanumeric and spaces only (no hyphens, underscores, or special symbols)
    const allowedSerialPattern = /^[a-zA-Z0-9\s]*$/;

    qcRows.forEach((row, index) => {
      const rowError: QcRowError = {};

      // Serial No validation
      if (!row.serial_no?.trim()) {
        rowError.serial_no = "Serial number is required";
        isValid = false;
      } else {
        const serialNo = row.serial_no.trim();
        
        // Check for special symbols
        // if (!allowedSerialPattern.test(serialNo)) {
        //   rowError.serial_no = "Special symbols are not allowed. Only letters, numbers, and spaces are permitted.";
        //   isValid = false;
        // } else 
        if (serialSet.has(serialNo)) {
          rowError.serial_no = "Duplicate serial number";
          isValid = false;
        } else {
          serialSet.add(serialNo);
        }
      }

      // Warranty date validation
      if (!row.warranty_date) {
        rowError.warranty_date = "Warranty date is required";
        isValid = false;
      }

      errors[index] = rowError;
    });

    setQcErrors(errors);
    return isValid;
  };

  const handleFinalSubmit = () => {
    // QC field validation
    const isQcValid = validateQcRows();

    if (!isQcValid) {
      // toast.error("Please fix highlighted Serial No / Warranty Date errors");
      toast.error("Please fill all the required fields");
      return;
    }

    // QC count validation
    const passCount = qcRows.filter(
      (row) => row.qc === STATUS_CONSTANT.PASS
    ).length;

    const failCount = qcRows.filter(
      (row) => row.qc === STATUS_CONSTANT.FAIL
    ).length;

    if (
      passCount !== (selectedItem?.quantity ?? 0) ||
      failCount !== (selectedItem?.damaged_quantity ?? 0)
    ) {
      Swal.fire({
        icon: "error",
        text: `Pass must be ${selectedItem?.quantity ?? 0} and Fail must be ${
          selectedItem?.damaged_quantity ?? 0
        }`,
      });
      return;
    }

    const updatedItems = [...items];
    updatedItems[selectedItemIndex] = {
      ...updatedItems[selectedItemIndex],
      grn_products: qcRows,
    };
    setItems(updatedItems);
    setQcRows([]);
    setQcErrors([]);
    setIsAddStockOpen(false);
  };

  return (
    <>
      <style>
        {`
                /* Optional – use only if needed */
.stock-table {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
}

.stock-table thead th {
  background-color: ${MecordColors.LightGrayColor};
  color: ${MecordColors.NormalText};
  font-weight: 500;
  text-align: center;        /* ✅ horizontal center */
}

.stock-table tbody tr:hover {
  background-color: ${MecordColors.LightGrayColorHover};
}

.stock-table td,
.stock-table th {
  vertical-align: middle;    /* ✅ vertical center */
  text-align: center;        /* ✅ horizontal center */
}


            `}
      </style>

      {/* Summary Table */}
      <div className="mb-4 mt-3" style={{ overflowX: "auto" }}>
        <Table className="table align-middle">
          <thead style={{ backgroundColor: MecordColors.LightGrayColor }}>
            <tr>
              <th style={{ minWidth: "100px" }}>Sr.No</th>
              <th style={{ minWidth: "150px" }}>Product Name</th>
              <th style={{ minWidth: "150px" }}>Product Code</th>
              <th style={{ minWidth: "150px" }}>Ordered Quantity</th>
              <th style={{ minWidth: "150px" }}>Unit</th>
              <th style={{ minWidth: "240px" }}>Received Quantity</th>
              <th style={{ minWidth: "240px" }}>Good Quantity</th>
              <th style={{ minWidth: "240px" }}>Damaged Quantity</th>
              <th style={{ minWidth: "180px" }}>Balance Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr key={item.product_id}>
              <td>1</td>
              <td>{item?.product_name}</td>
              <td>{item?.product_code}</td>
              <td>{item?.order_quantity}</td>
              <td>{item?.unit_name}</td>
              <td>{item?.received_quantity || 0}</td>
              <td>{item?.quantity || 0}</td>
              <td>{item?.damaged_quantity || 0}</td>
              <td>{item?.balance_quantity ?? 0}</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <hr />

      {/* Form Table */}
      <div className="mb-4" style={{ overflowX: "auto" }}>
        <Table className="stock-table" bordered>
          <thead>
            <tr>
              <th style={{ minWidth: "100px" }}>Sr No.</th>
              <th style={{ minWidth: "180px" }}>Product Name</th>
              <th style={{ minWidth: "180px" }}>Warranty Date</th>
              <th style={{ minWidth: "180px" }}>Serial No.</th>
              <th style={{ minWidth: "180px" }}>QC</th>
              <th style={{ minWidth: "180px" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {qcRows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{selectedItem?.product_name}</td>
                {/* Warranty Date */}
                <td>
                  <Form.Control
                    type="date"
                    value={row.warranty_date}
                    min={formik.values.received_date?.split("T")?.[0]}
                    isInvalid={!!qcErrors[index]?.warranty_date}
                    onChange={(e) =>
                      handleQcChange(index, "warranty_date", e.target.value)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {qcErrors[index]?.warranty_date}
                  </Form.Control.Feedback>
                </td>

                {/* Serial No */}
                <td>
                  <Form.Control
                    type="text"
                    value={row.serial_no}
                    isInvalid={!!qcErrors[index]?.serial_no}
                    placeholder="Enter Serial No"
                    onChange={(e) =>
                      handleQcChange(index, "serial_no", e.target.value)
                    }
                    // onBlur={() => {
                    //   // Validate on blur to ensure error persists if needed
                    //   const serialNo = row.serial_no?.trim() || "";
                    //   const allowedPattern = /^[a-zA-Z0-9\s]*$/;
                    //   if (serialNo && !allowedPattern.test(serialNo)) {
                    //     const updatedErrors = [...qcErrors];
                    //     if (!updatedErrors[index]) {
                    //       updatedErrors[index] = {};
                    //     }
                    //     updatedErrors[index].serial_no = "Special symbols are not allowed. Only letters, numbers, and spaces are permitted.";
                    //     setQcErrors(updatedErrors);
                    //   }
                    // }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {qcErrors[index]?.serial_no}
                  </Form.Control.Feedback>
                </td>

                {/* QC */}
                <td>
                  <span
                    className={
                      row.qc === STATUS_CONSTANT.PASS
                        ? "text-success fw-bold"
                        : "text-danger fw-bold"
                    }
                  >
                    {row.qc}
                  </span>
                </td>

                {/* Remarks */}
                <td>
                  <Form.Control
                    type="text"
                    value={row.remarks}
                    onChange={(e) =>
                      handleQcChange(index, "remarks", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-center gap-3 py-3">

        <CancelButton
        showConfirmation={false}
          onClick={() => {
            showConfirm("Any unsaved changes will be lost.").then((result) => {
              if (result.isConfirmed) {
                setIsAddStockOpen(false);
                setRowData([]);
              }
            });
          }}    
                          />
        {/* <CancelBackButton
          to=""
          // label="Back"
          onClick={() => {
            showConfirm("Any unsaved changes will be lost.").then((result) => {
              if (result.isConfirmed) {
                setIsAddStockOpen(false);
                setRowData([]);
              }
            });
          }}
        /> */}
        <PrimarySubmitButton type="button" onClick={handleFinalSubmit} />
      </div>
    </>
  );
};

export default ItemInwardAddStock;
